import NavbarSkeleton from "@/components/Skeleton/NavbarSkeleton";
import LeftIcon from "@/components/Svg/LeftIcon";
import useCategoryMenu from "@/hooks/useCategoryMenu";
import { HeaderMenuType } from "@/types/HeaderType";
import { ArrowDown2 } from "iconsax-react";
import Link from "next/link";
import React, { useEffect, useState, useRef } from "react";

function NavContent() {
  const generalLinks = `text-sm text-ws-gray-600`;
  const flexItems = `flex items-center`;
  const arrowDownIcon = `arrow-down transition-transform duration-300`;
  const megaMenu = `w-screen absolute left-0 gap-4`;
  const navLinks = `nav-links text-sm ${flexItems} p-2 gap-1 rounded-lg text-ws-gray-500 duration-300 hover:bg-ws-gray-800 hover:text-ws-white-100`;
  const subNavLinks = `sub-nav-links text-sm ${flexItems} p-2 gap-1 rounded-lg text-ws-gray-500 duration-300 w-20`;
  const navLi = `mega-menu-item transition-all `;
  const subLinkLi = `sub-link rounded-lg w-48  h-max`;
  const subLinkMegaMenu = `flex flex-col flex-wrap h-80 gap-2`;
  const subSubLink = `flex flex-col`;

  const [headerMenu, setHeaderMenu] = useState<HeaderMenuType[]>([]);
  const [activeMenu, setActiveMenu] = useState<number | null>(null);
  const [activeSubMenu, setActiveSubMenu] = useState<number | null>(null);
  const menuRef = useRef<HTMLDivElement>(null);
  const { data, isLoading } = useCategoryMenu();
  const timeoutRef = useRef<NodeJS.Timeout | null>(null);

  const handleOverlayHover = () => {
    setActiveMenu(null);
  };
  useEffect(() => {
    if (data?.isSuccess) {
      setHeaderMenu(data?.data || []);
    }
  }, [data]);

  return (
    <div className="flex w-full justify-between num-vazir " ref={menuRef}>
      {isLoading ? (
        <NavbarSkeleton />
      ) : (
        <ul
          className={`${flexItems}  gap-2 lg:h-16 lg:mt-0 mt-5 h-auto items-center transition-all duration-300 lg:flex-row lg:w-auto flex-col w-full `}
        >
          {headerMenu.slice(0, 6).map((header) => (
            <li
              key={header.id}
              className={navLi}
              onMouseEnter={() => {
                if (timeoutRef.current) {
                  clearTimeout(timeoutRef.current);
                }
                timeoutRef.current = setTimeout(() => {
                  setActiveMenu(header.id);
                }, 300);
              }}
              onMouseLeave={() => {
                if (timeoutRef.current) {
                  clearTimeout(timeoutRef.current);
                }
                setActiveMenu(null);
              }}
              onClick={() => setActiveMenu(null)}
            >
              <Link
                className={`${navLinks} ${
                  activeMenu === header.id
                    ? "bg-ws-gray-600 text-ws-white-100 num-vazir"
                    : ""
                }`}
                href={`/category/${header?.name}/${header?.id}`}
              >
                {header?.name}
                {header?.childs?.length ? (
                  <ArrowDown2
                    className={`${arrowDownIcon} ${
                      activeMenu === header.id ? "rotate-180" : ""
                    }`}
                    color={activeMenu === header.id ? "#ffffff" : "#686868"}
                    size={10}
                  />
                ) : null}
              </Link>
              {header?.childs?.length > 0 && activeMenu === header.id && (
                <div
                  className={` ${megaMenu} num-vazir top-full z-70 bg-white w-full py-3`}
                >
                  <div
                    onMouseEnter={handleOverlayHover}
                    className="absolute top-full left-0 w-screen h-[calc(100vh-64px)] bg-black/65 z-60"
                  ></div>
                  <section className={`h-80`}>
                    <div className="my-3 px-20 relative flex flex-col gap-3 scrollbar-navbar h-75 overflow-auto">
                      {header?.childs?.slice(0, 20)?.map((child) => (
                        <li
                          key={child?.id}
                          className={`z-20 ${subLinkLi} `}
                          onMouseEnter={() => setActiveSubMenu(child.id)}
                          onMouseLeave={() => setActiveSubMenu(null)}
                        >
                          <Link
                            className={`${subNavLinks} w-full! z-20 flex items-start justify-between`}
                            href={`/category/${child?.name}/${child?.id}`}
                          >
                            {child?.name}
                            {child?.childs?.length > 0 ? (
                              <LeftIcon className="w-3 h-3 stroke-black! " />
                            ) : (
                              ""
                            )}
                          </Link>
                          {child?.childs?.length > 0 &&
                            activeSubMenu === child.id && (
                              <div
                                className="w-4/5 sublink-before h-80  right-62.5 z-10 pr-10! fixed! top-42.5!"
                                onMouseEnter={() => setActiveSubMenu(child.id)}
                                onMouseLeave={() => setActiveSubMenu(null)}
                              >
                                <ul
                                  className={`${subLinkMegaMenu} sublink-before w-max  right-62.5 z-10 pr-10! fixed! top-42.5!`}
                                >
                                  {child?.childs
                                    ?.slice(0, 10)
                                    ?.map((finalChild) => (
                                      <li
                                        key={finalChild?.id}
                                        className={`${subLinkLi}  text-sm relative right-0! p-2`}
                                      >
                                        <Link
                                          className={subSubLink}
                                          href={`/category/${finalChild?.name}/${finalChild?.id}`}
                                        >
                                          {finalChild?.name}
                                        </Link>
                                      </li>
                                    ))}
                                </ul>
                              </div>
                            )}
                        </li>
                      ))}
                    </div>
                  </section>
                </div>
              )}
            </li>
          ))}
        </ul>
      )}
      <div
        className={`flex gap-8 lg:flex-row flex-col lg:items-center items-start lg:w-auto w-full`}
      >
        <Link className={generalLinks} href="/blogList">
          بلاگ
        </Link>
        <Link className={generalLinks} href="/about">
          درباره ما
        </Link>
        <Link className={generalLinks} href="/contact">
          تماس با ما
        </Link>
      </div>
    </div>
  );
}

export default NavContent;
